var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/domain/enums.ts
import { z } from "zod";
var ContainerTypeEnum = z.enum([
  "meditation",
  "chant",
  "meal",
  "work",
  "physical_practice",
  "teaching",
  "sleep"
]);
var NodeTypeEnum = z.enum([
  "text",
  "audio",
  "silence",
  "bell",
  "instruction",
  "branch",
  "composite",
  "retreat_complete",
  "announcement"
]);
var EdgeTypeEnum = z.enum(["sequential", "parallel", "offset"]);
var ExecutionPlaneEnum = z.enum(["primary", "overlay", "system"]);
var ExecutionStateEnum = z.enum(["idle", "running", "paused", "completed"]);
var OverlayEventTypeEnum = z.enum([
  "bell_start",
  "bell_end",
  "announcement",
  "interval_cue"
]);
var SystemEventTypeEnum = z.enum([
  "screen_wake_lock",
  "alarm_schedule",
  "background_timer"
]);

// src/domain/nodes.ts
import { z as z2 } from "zod";
var TextNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("text"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().positive(),
  contentKey: z2.string().regex(/^[\w.]+$/),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var AudioNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("audio"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().positive(),
  audioAssetId: z2.string().uuid(),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var SilenceNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("silence"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().nonnegative(),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var BellNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("bell"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().positive(),
  bellCount: z2.number().int().positive(),
  bellPatternId: z2.string().optional(),
  // BellPatternId from @retreat/bells
  audioAssetId: z2.string().uuid(),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var InstructionNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("instruction"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().positive(),
  contentKey: z2.string().regex(/^[\w.]+$/),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var BranchNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("branch"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().nonnegative(),
  condition: z2.string(),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var CompositeNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("composite"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().positive(),
  childNodeIds: z2.array(z2.string().uuid()),
  containerId: z2.string().uuid().optional(),
  metadata: z2.unknown().optional()
});
var RetreatCompleteNodeSchema = z2.object({
  id: z2.string().uuid(),
  type: z2.literal("retreat_complete"),
  plane: ExecutionPlaneEnum,
  durationSeconds: z2.number().int().nonnegative()
});
var NodeSchema = z2.union([
  TextNodeSchema,
  AudioNodeSchema,
  SilenceNodeSchema,
  BellNodeSchema,
  InstructionNodeSchema,
  BranchNodeSchema,
  CompositeNodeSchema,
  RetreatCompleteNodeSchema
]);

// src/domain/edge.ts
import { z as z3 } from "zod";
var EdgeSchema = z3.object({
  id: z3.string().uuid(),
  fromNodeId: z3.string().uuid(),
  toNodeId: z3.string().uuid(),
  type: EdgeTypeEnum,
  offsetSeconds: z3.number().int().nonnegative().optional()
});

// src/domain/dag.ts
import { z as z4 } from "zod";
var ExecutionDAGSchema = z4.object({
  id: z4.string().uuid(),
  retreatId: z4.string().uuid(),
  version: z4.string(),
  nodes: z4.array(NodeSchema),
  edges: z4.array(EdgeSchema),
  entryNodeId: z4.string().uuid(),
  exitNodeId: z4.string().uuid().optional(),
  totalDurationSeconds: z4.number().int().positive()
});

// src/domain/bells.ts
import { z as z5 } from "zod";
var SPIRITUAL_FAMILY_IDS = [
  "buddhist",
  // Zen, Tibetan, Theravada, Chan, Korean, Vipassana, Plum Village
  "yogic",
  // Hatha, Kundalini, Vedanta, Bhakti, Tantra
  "abrahamic",
  // Christian contemplative, Jewish meditation, Sufi dhikr
  "dharmic",
  // Jainism, Sikh meditation, Hindu devotional
  "indigenous",
  // West African, shamanic, cacao ceremony, First Nations
  "movement",
  // 5Rhythms, Biodanza, contact improv, somatic
  "secular"
  // MBSR, secular mindfulness, wellness, corporate
];
var SPIRITUAL_FAMILY_META = {
  buddhist: {
    displayName: "Buddhist",
    description: "2,500-year tradition spanning Asia and the West",
    color: "#8B6914"
  },
  yogic: {
    displayName: "Yogic",
    description: "Indian contemplative and movement traditions",
    color: "#C65D1A"
  },
  abrahamic: {
    displayName: "Abrahamic",
    description: "Christian, Jewish, and Sufi contemplative lineages",
    color: "#4A6741"
  },
  dharmic: {
    displayName: "Dharmic",
    description: "Jain, Sikh, and Hindu meditative practice",
    color: "#7B3F91"
  },
  indigenous: {
    displayName: "Indigenous",
    description: "Earth-based and ancestral ceremony traditions",
    color: "#8B3A1C"
  },
  movement: {
    displayName: "Movement & Dance",
    description: "Somatic, dance, and embodiment retreat lineages",
    color: "#1A5C7A"
  },
  secular: {
    displayName: "Secular Mindfulness",
    description: "MBSR, modern wellness, and non-sectarian practice",
    color: "#3D5A80"
  }
};
var BELL_INSTRUMENT_IDS = [
  // ── Buddhist: Japanese Zen ──────────────────────────────────────────────────
  "rin",
  // 鈴     small bronze meditation bowl — the zazen bell
  "ogane",
  // 大鐘   great temple bell — deep "tong", 14s+ resonance
  "inkin",
  // 引磬   small hand bell — ceremony and procession
  "mokugyo",
  // 木魚   wooden fish drum — chanting rhythm
  "han",
  // 板     life-and-death board — retreat opening sequence
  "hyoshigi",
  // 拍子木 wooden clappers — kinhin (walking meditation) markers
  "keisu",
  // 磬子   medium bronze bowl — altar ceremony transitions
  // ── Buddhist: Tibetan / Vajrayana ──────────────────────────────────────────
  "tingsha",
  // 丁夏   Tibetan cymbals — clarity bell; puja + mindfulness
  "drilbu",
  // དྲིལ་བུ  Tibetan hand bell (held with vajra) — puja, deity invocation
  "singing_bowl",
  // 頌缽   Himalayan brass singing bowl — deeper, warmer than rin
  "damaru",
  // ཌཱ་མ་རུ  double-headed hand drum — Chöd, Vajrayana ceremony
  // ── Buddhist: Chinese Mahayana ──────────────────────────────────────────────
  "yunqing",
  // 雲磬   cloud gong — thin bronze disc; bright metallic ring
  "zhong",
  // 鐘     Chinese temple bell — 108 morning strikes
  // ── Buddhist: Korean ────────────────────────────────────────────────────────
  "moktak",
  // 목탁   Korean wooden block — hollow, sharp; chanting rhythm
  "beomjong",
  // 범종   Korean temple bell — deep; eumgwan resonance
  // ── Buddhist: Vipassana / Theravada ─────────────────────────────────────────
  "vipassana_gong",
  // Goenka tradition thick brass bowl — warm, full, steady
  // ── Yogic (stub — audio not yet synthesized) ─────────────────────────────────
  "tibetan_crystal_bowl",
  // quartz crystal singing bowl — clear, high, sustained
  "om_gong",
  // large Indian gong struck for OM — deep, expansive
  "kirtana_kartals",
  // small brass hand cymbals — Bhakti kirtan rhythm
  // ── Abrahamic (stub — audio not yet synthesized) ─────────────────────────────
  "church_bell",
  // Western church bell — bronze, domed; Benedictine hours
  "prayer_chime",
  // tubular chime — used in Christian centering prayer
  "singing_bowl_quartz",
  // quartz bowl used in some Christian meditation centers
  // ── Dharmic (stub — audio not yet synthesized) ───────────────────────────────
  "ghanta",
  // Hindu/Jain temple bell — different timbre from drilbu
  "kartals",
  // Sikh hand cymbals — similar to tingsha, paired rhythm
  // ── Indigenous (stub — audio not yet synthesized) ────────────────────────────
  "djembe",
  // West African hand drum — goblet-shaped; talking drum
  "balafon",
  // West African xylophone — wooden keys + gourd resonators
  "frame_drum",
  // universal shamanic drum — found across traditions
  // ── Movement (stub — audio not yet synthesized) ──────────────────────────────
  "tongue_drum",
  // steel tongue drum — melodic; used in 5Rhythms + yoga
  "ocean_drum"
  // frame drum with beads — gentle rhythmic marker
];
var SYNTHESIZED_INSTRUMENT_IDS = /* @__PURE__ */ new Set([
  "rin",
  "ogane",
  "inkin",
  "mokugyo",
  "han",
  "hyoshigi",
  "keisu",
  "tingsha",
  "drilbu",
  "singing_bowl",
  "damaru",
  "yunqing",
  "zhong",
  "moktak",
  "beomjong",
  "vipassana_gong"
]);
var BELL_PATTERN_IDS = [
  // ── Single strikes (tradition-neutral) ──────────────────────────────────────
  "rin_single",
  // 1 rin — closes meditation, general marker
  "ogane_single",
  // 1 deep ogane — major transition / ceremony open
  "inkin_single",
  // 1 inkin — precise ceremony beat
  "keisu_single",
  // 1 keisu — grounding close
  "tingsha_pair",
  // tingsha struck together once — Tibetan marker
  "vipassana_gong_single",
  // 1 vipassana gong — Goenka session boundary
  // ── Japanese Zen: Meditation (zazen) ────────────────────────────────────────
  "zazen_deep_open",
  // ogane + rin × 3 — sesshin zazen open (deep bell then triple rin)
  "zazen_open",
  // 3 rin strikes (3.8s apart) — opens sitting period
  "zazen_close",
  // keisu + rin — closes sitting period
  "zazen_interval",
  // 1 rin — midpoint mindfulness bell during sitting
  // ── Japanese Zen: Composite ──────────────────────────────────────────────────
  "oryoki_meal_bell",
  // keisu + mokugyo × 8 simultaneous — traditional oryoki meal open
  // ── Japanese Zen: Walking meditation (kinhin) ─────────────────────────────────
  "kinhin_begin",
  // 1 ogane + 2 hyoshigi — announces start of kinhin
  "kinhin_interval",
  // 1 inkin — mindfulness mark during walking
  "kinhin_end",
  // 2 hyoshigi — announces return to cushion
  // ── Japanese Zen: Chanting ──────────────────────────────────────────────────
  "chant_begin",
  // 3 rin + inkin — opens chanting period
  "chant_mokugyo",
  // 8 mokugyo at chanting tempo — rhythmic pulse
  "chant_end",
  // 2 inkin — closes chanting period
  // ── Japanese Zen: Ceremony ──────────────────────────────────────────────────
  "ceremony_incense",
  // 1 inkin — at incense offering moment
  "ceremony_bow",
  // 1 keisu — accompanies formal bow (sampai)
  // ── Japanese Zen: Retreat framing ───────────────────────────────────────────
  "han_opening",
  // 22-strike han sequence (slow → urgent → grave)
  "han_closing",
  // 3 slow han strikes — formal retreat close
  // ── Tibetan / Vajrayana ─────────────────────────────────────────────────────
  "puja_drilbu",
  // 3 drilbu strikes — opens Tibetan puja
  "singing_bowl_rim",
  // singing bowl struck — long sustain settling marker
  "tingsha_ceremony",
  // 3 tingsha pairs with 5s silence — clearing ceremony
  "damaru_ceremony",
  // damaru rapid rotation — Chöd / Vajrayana offering
  // ── Chinese Mahayana ────────────────────────────────────────────────────────
  "morning_108",
  // zhong × 27 (compressed 108 afflictions) — morning ceremony
  "yunqing_ceremony",
  // 3 yunqing — Chinese ceremony marker
  "zhong_single",
  // 1 zhong — major Chinese transition
  // ── Korean ──────────────────────────────────────────────────────────────────
  "moktak_chant",
  // 8 moktak — Korean chanting tempo
  "four_instruments_begin",
  // beomjong + moktak — Korean morning service open
  // ── Vipassana (Goenka) ──────────────────────────────────────────────────────
  "goenka_session_start",
  // 1 vipassana_gong — session begins
  "goenka_session_end",
  // 1 vipassana_gong — session ends
  "goenka_adhitthana_bell",
  // 3 vipassana_gong — Adhitthana strong-determination sit open/close
  // ── Universal ───────────────────────────────────────────────────────────────
  "mindfulness_bell"
  // 1 rin — Plum Village, MBSR, secular mindfulness
];
var BELL_PATTERN_RING_OUT_MS = {
  // ── Single strikes ──────────────────────────────────────────────────────────
  rin_single: 7e3,
  ogane_single: 16e3,
  inkin_single: 3500,
  keisu_single: 9e3,
  tingsha_pair: 5e3,
  vipassana_gong_single: 1e4,
  // ── Japanese Zen: Meditation ──────────────────────────────────────────────────
  zazen_deep_open: 18e3,
  zazen_open: 12e3,
  zazen_close: 12e3,
  zazen_interval: 7e3,
  // ── Japanese Zen: Composite ───────────────────────────────────────────────────
  oryoki_meal_bell: 9e3,
  // ── Japanese Zen: Kinhin ──────────────────────────────────────────────────────
  kinhin_begin: 8e3,
  kinhin_interval: 3500,
  kinhin_end: 2e3,
  // ── Japanese Zen: Chanting ────────────────────────────────────────────────────
  chant_begin: 14e3,
  chant_mokugyo: 7e3,
  chant_end: 5e3,
  // ── Japanese Zen: Ceremony ────────────────────────────────────────────────────
  ceremony_incense: 3500,
  ceremony_bow: 9e3,
  // ── Japanese Zen: Retreat framing ─────────────────────────────────────────────
  han_opening: 42e3,
  han_closing: 11e3,
  // ── Tibetan / Vajrayana ───────────────────────────────────────────────────────
  puja_drilbu: 12e3,
  singing_bowl_rim: 12e3,
  tingsha_ceremony: 15e3,
  damaru_ceremony: 5e3,
  // ── Chinese Mahayana ──────────────────────────────────────────────────────────
  morning_108: 9e4,
  yunqing_ceremony: 12e3,
  zhong_single: 12e3,
  // ── Korean ────────────────────────────────────────────────────────────────────
  moktak_chant: 7e3,
  four_instruments_begin: 18e3,
  // ── Vipassana (Goenka) ────────────────────────────────────────────────────────
  goenka_session_start: 1e4,
  goenka_session_end: 1e4,
  goenka_adhitthana_bell: 18e3,
  // ── Universal ─────────────────────────────────────────────────────────────────
  mindfulness_bell: 7e3
};
var TRADITION_IDS = [
  // ── Buddhist ─────────────────────────────────────────────────────────────────
  // Japanese Zen
  "soto_zen",
  // Eiheiji, Sōjiji, SFZC, Tassajara
  "rinzai_zen",
  // Daitoku-ji, Myōshin-ji, Dai Bosatsu, Dai Tokoji
  "obaku_zen",
  // Manpuku-ji; Chinese-influenced Japanese Zen
  // Tibetan
  "tibetan_gelug",
  // Ganden, Drepung, Sera, Tashi Lhunpo
  "tibetan_nyingma",
  // Larung Gar, Shechen, Namdroling
  "tibetan_kagyu",
  // Rumtek, Karma Triyana Dharmachakra
  "tibetan_sakya",
  // Sakya Monastery, Tsechen Kunchab
  "tibetan_bon",
  // Menri Monastery, Triten Norbutse (pre-Buddhist Tibetan)
  // Chinese
  "chinese_chan",
  // Shaolin, Gao Min, Linji / Caodong
  "chinese_pure_land",
  // Hsi Lai, Fo Guang Shan, Lingyan Shan
  "chinese_tiantai",
  // Guoqing Temple, Tiantai Shan
  // Korean
  "korean_jogye",
  // Jogyesa, Haeinsa, Tongdosa, Songgwangsa
  "korean_taego",
  // Bongeunsa, Seonamsa
  // Theravada
  "theravada_thai",
  // Wat Pa Pong, Amaravati, Abhayagiri
  "theravada_burmese",
  // Mahasi Sayadaw, Pa-Auk
  "theravada_sri_lankan",
  // Vajirarama, Island Hermitage
  // Vipassana
  "vipassana_goenka",
  // Dhamma Giri, all 150+ Dhamma centers worldwide
  "vipassana_insight",
  // Spirit Rock, IMS Barre, Gaia House
  // Contemporary Buddhist
  "plum_village",
  // Thich Nhat Hanh — Plum Village, Deer Park, Blue Cliff
  "shambhala",
  // Chogyam Trungpa — non-sectarian Tibetan / secular
  "modern_secular",
  // MBSR, secular mindfulness programs
  // ── Yogic ────────────────────────────────────────────────────────────────────
  "hatha_yoga",
  // asana + pranayama retreat; Iyengar, Ashtanga, Yin
  "kundalini_yoga",
  // Yogi Bhajan tradition; 3HO retreats
  "vedanta",
  // Advaita Vedanta study retreat; Ramana Maharshi, Chinmaya
  "bhakti_yoga",
  // devotional; kirtan retreat; Vrindavan, Amma, Krishna Das
  // ── Abrahamic ────────────────────────────────────────────────────────────────
  "christian_contemplative",
  // Centering Prayer, Lectio Divina; Benedictine, Cistercian
  "jewish_meditation",
  // Mussar, Reb Zalman, Jewish Renewal, Tanya
  "sufi_dhikr",
  // Sufi whirling, zikr, sema; Rumi / Mevlevi Order
  // ── Dharmic ──────────────────────────────────────────────────────────────────
  "jainism",
  // Jain meditation retreat; Preksha Dhyana, Samayika
  "sikh_simran",
  // Naam simran, Gurbani meditation; Gurdwara retreat
  // ── Indigenous ───────────────────────────────────────────────────────────────
  "west_african",
  // Dagara, Yoruba-inspired, West African ceremony
  "shamanic_core",
  // Core shamanism; Michael Harner / Foundation for Shamanic Studies
  "cacao_ceremony",
  // Central American / Mayan-inspired heart-opening ceremony
  // ── Movement ─────────────────────────────────────────────────────────────────
  "five_rhythms",
  // Gabrielle Roth's 5Rhythms dance
  "biodanza",
  // Rolando Toro's Biodanza
  "authentic_movement",
  // Janet Adler's Authentic Movement; somatic retreat
  // ── Secular ──────────────────────────────────────────────────────────────────
  "wellbeing_corporate",
  // corporate wellness, leadership retreat
  "grief_ritual",
  // Francis Weller / grief tending; non-sectarian
  "nature_immersion"
  // forest bathing, wilderness retreat, Shinrin-yoku
];
var TRADITION_FAMILY = {
  // Buddhist
  soto_zen: "buddhist",
  rinzai_zen: "buddhist",
  obaku_zen: "buddhist",
  tibetan_gelug: "buddhist",
  tibetan_nyingma: "buddhist",
  tibetan_kagyu: "buddhist",
  tibetan_sakya: "buddhist",
  tibetan_bon: "buddhist",
  chinese_chan: "buddhist",
  chinese_pure_land: "buddhist",
  chinese_tiantai: "buddhist",
  korean_jogye: "buddhist",
  korean_taego: "buddhist",
  theravada_thai: "buddhist",
  theravada_burmese: "buddhist",
  theravada_sri_lankan: "buddhist",
  vipassana_goenka: "buddhist",
  vipassana_insight: "buddhist",
  plum_village: "buddhist",
  shambhala: "buddhist",
  modern_secular: "secular",
  // Yogic
  hatha_yoga: "yogic",
  kundalini_yoga: "yogic",
  vedanta: "yogic",
  bhakti_yoga: "yogic",
  // Abrahamic
  christian_contemplative: "abrahamic",
  jewish_meditation: "abrahamic",
  sufi_dhikr: "abrahamic",
  // Dharmic
  jainism: "dharmic",
  sikh_simran: "dharmic",
  // Indigenous
  west_african: "indigenous",
  shamanic_core: "indigenous",
  cacao_ceremony: "indigenous",
  // Movement
  five_rhythms: "movement",
  biodanza: "movement",
  authentic_movement: "movement",
  // Secular
  wellbeing_corporate: "secular",
  grief_ritual: "secular",
  nature_immersion: "secular"
};
var BellSpecSchema = z5.object({
  patternId: z5.enum(BELL_PATTERN_IDS),
  volumeAdjust: z5.number().optional()
});

// src/domain/containers.ts
import { z as z6 } from "zod";
var bellPatternField = z6.enum(BELL_PATTERN_IDS).optional();
var MeditationContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("meditation"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  posture: z6.enum(["seated", "standing", "walking", "lying"]),
  bellsBefore: z6.number().int().nonnegative(),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative(),
  bellAfterPattern: bellPatternField,
  optionalKinhin: z6.boolean(),
  metadata: z6.unknown().optional()
});
var ChantContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("chant"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  chantName: z6.string().regex(/^[\w.]+$/),
  times: z6.number().int().positive(),
  language: z6.string(),
  audioAssetId: z6.string().uuid(),
  bellsBefore: z6.number().int().nonnegative().default(1),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(1),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var MealContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("meal"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  mealType: z6.enum(["breakfast", "lunch", "dinner", "snack"]),
  mindfulPractice: z6.boolean(),
  bellsBefore: z6.number().int().nonnegative().default(1),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(0),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var WorkContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("work"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  workType: z6.string(),
  bellsBefore: z6.number().int().nonnegative().default(1),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(1),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var PhysicalPracticeContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("physical_practice"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  practiceType: z6.string(),
  bellsBefore: z6.number().int().nonnegative().default(1),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(1),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var TeachingContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("teaching"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  teachingTopic: z6.string(),
  bellsBefore: z6.number().int().nonnegative().default(0),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(0),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var SleepContainerSchema = z6.object({
  id: z6.string().uuid(),
  type: z6.literal("sleep"),
  name: z6.string().min(1).max(200),
  description: z6.string().optional(),
  traditionTerm: z6.string().optional(),
  durationSeconds: z6.number().int().positive(),
  bellsBefore: z6.number().int().nonnegative().default(0),
  bellBeforePattern: bellPatternField,
  bellsAfter: z6.number().int().nonnegative().default(1),
  bellAfterPattern: bellPatternField,
  metadata: z6.unknown().optional()
});
var ContainerSchema = z6.discriminatedUnion("type", [
  MeditationContainerSchema,
  ChantContainerSchema,
  MealContainerSchema,
  WorkContainerSchema,
  PhysicalPracticeContainerSchema,
  TeachingContainerSchema,
  SleepContainerSchema
]);

// src/utils/uuid.js
function generateUUID() {
  if (typeof globalThis !== "undefined" && "crypto" in globalThis && globalThis.crypto.getRandomValues) {
    const arr = new Uint8Array(16);
    globalThis.crypto.getRandomValues(arr);
    arr[6] = arr[6] & 15 | 64;
    arr[8] = arr[8] & 63 | 128;
    const hex = Array.from(arr).map((x) => x.toString(16).padStart(2, "0")).join("");
    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20, 32)
    ].join("-");
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}

export {
  __require,
  __commonJS,
  __toESM,
  ContainerTypeEnum,
  NodeTypeEnum,
  EdgeTypeEnum,
  ExecutionPlaneEnum,
  ExecutionStateEnum,
  OverlayEventTypeEnum,
  SystemEventTypeEnum,
  TextNodeSchema,
  AudioNodeSchema,
  SilenceNodeSchema,
  BellNodeSchema,
  InstructionNodeSchema,
  BranchNodeSchema,
  CompositeNodeSchema,
  RetreatCompleteNodeSchema,
  NodeSchema,
  EdgeSchema,
  ExecutionDAGSchema,
  SPIRITUAL_FAMILY_IDS,
  SPIRITUAL_FAMILY_META,
  BELL_INSTRUMENT_IDS,
  SYNTHESIZED_INSTRUMENT_IDS,
  BELL_PATTERN_IDS,
  BELL_PATTERN_RING_OUT_MS,
  TRADITION_IDS,
  TRADITION_FAMILY,
  BellSpecSchema,
  MeditationContainerSchema,
  ChantContainerSchema,
  MealContainerSchema,
  WorkContainerSchema,
  PhysicalPracticeContainerSchema,
  TeachingContainerSchema,
  SleepContainerSchema,
  ContainerSchema,
  generateUUID
};
